export const PAYMENT_METHODS = {
	CASH: 'cash',
	CARD: 'card'
};
